/* eslint-disable no-unused-vars */
import * as S from './Separators.styled';
import PropTypes from 'prop-types';

const separatorTypes = {
  small: 'small',
  medium: 'medium',
  big: 'big',
  dashed: 'dashed',
  dotted: 'dotted',
  with_label: 'with_label',
};

export const Separators = ({ type, label, style, labelBackground }) => {
  return <S.Container style={style} type={type} label={label} labelBackground={labelBackground} />;
};

Separators.separatorTypes = { ...separatorTypes };

Separators.propTypes = {
  type: PropTypes.oneOf(Object.values(separatorTypes)).isRequired,
  label: (props, propName, componentName) => {
    if (
      props.type === 'with_label' &&
      (props[propName] === undefined || typeof props[propName] !== 'string')
    ) {
      return console.error(
        `Prop '${propName}' is required when type is 'with_label' in Separators.`,
      );
    }
  },
  labelBackground: (props, propName, componentName) => {
    if (
      props.type === 'with_label' &&
      (props[propName] === undefined || typeof props[propName] !== 'string')
    ) {
      return console.error(
        `Prop '${propName}' is required when type is 'with_label' in Separators.`,
      );
    }
  },
  style: PropTypes.object,
};
